import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { selectIsAuthenticated } from "../../redux/authentication/selectors";
import { getLocalAccessToken } from "../../utils/helpers";

const PublicRoute = ({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const accessToken = getLocalAccessToken();
  const auth = !!(isAuthenticated && accessToken);
  return auth ? <Navigate to="/dashboard" /> : children;
};

export default PublicRoute;
